export enum BidVersionType {
  DRAFT_VERSION = 'DRAFT_VERSION',
  CURRENT_VERSION = 'CURRENT_VERSION',
  HISTORIC_VERSION = 'HISTORIC_VERSION'
}
